import React, { useEffect, useState } from 'react';
import { useTalentos } from '../../../../application/talentos/hooks/useTalentos';
import ToolbarComponent from '../../../ui/section';
import Loader from '../../../ui/loader';
import './detail.css';

const ApplicationDetailPage = (props) => {
    const { getApplicationById, isLoading, error } = useTalentos();
    const [application, setApplication] = useState(null);

    useEffect(() => {
        const id = props.match?.params?.id;
        if (id) {
            loadApplication(id);
        }
    }, [props.match?.params?.id]);

    const loadApplication = async (id) => {
        try {
            const data = await getApplicationById(id);
            setApplication(data);
        } catch (err) {
            console.error('Error al cargar postulación:', err);
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '-';
        const date = new Date(dateString);
        return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const translateStage = (stage) => {
        const translations = {
            'received': 'Recibida',
            'in_review': 'En revisión',
            'interview': 'Entrevista',
            'offer': 'Oferta',
            'hired': 'Contratado',
            'rejected': 'Rechazado'
        };
        return translations[stage] || stage;
    };

    const translateStatus = (status) => {
        const translations = {
            'active': 'Activa',
            'withdrawn': 'Retirada',
            'closed': 'Cerrada'
        };
        return translations[status] || status;
    };

    const getStageColor = (stage) => {
        const colors = {
            received: '#6B7280',
            in_review: '#3B82F6',
            interview: '#8B5CF6',
            offer: '#10B981',
            hired: '#059669',
            rejected: '#EF4444'
        };
        return colors[stage] || '#6B7280';
    };

    const getStatusColor = (status) => {
        const colors = {
            active: '#10B981',
            withdrawn: '#F59E0B',
            closed: '#6B7280'
        };
        return colors[status] || '#6B7280';
    };

    if (isLoading) {
        return (
            <ToolbarComponent label="Detalle de Postulación" showBackButton={true} onBackClick={() => props.history.goBack()}>
                <Loader text="Cargando postulación..." />
            </ToolbarComponent>
        );
    }

    if (error || !application) {
        return (
            <ToolbarComponent label="Detalle de Postulación" showBackButton={true} onBackClick={() => props.history.goBack()}>
                <div className="error-message">
                    {error || 'No se pudo cargar la postulación'}
                </div>
            </ToolbarComponent>
        );
    }

    const jobOrPractice = application.job || application.practice;
    const user = application.user;

    return (
        <ToolbarComponent label="Detalle de Postulación" showBackButton={true} onBackClick={() => props.history.goBack()}>
            <div className="application-detail-container">
                {/* Header */}
                <div className="detail-header">
                    <div>
                        <h1 className="detail-title">Postulación</h1>
                        <p className="detail-subtitle">
                            {jobOrPractice?.title || 'Sin título'}
                        </p>
                    </div>
                    <div className="detail-badges">
                        <span 
                            className="status-badge"
                            style={{ 
                                background: `${getStatusColor(application.status)}20`,
                                color: getStatusColor(application.status)
                            }}
                        >
                            {translateStatus(application.status)}
                        </span>
                        <span 
                            className="stage-badge"
                            style={{ 
                                background: `${getStageColor(application.currentStage)}20`,
                                color: getStageColor(application.currentStage)
                            }}
                        >
                            {translateStage(application.currentStage)}
                        </span>
                    </div>
                </div>

                {/* Información del Postulante */}
                {user && (
                    <div className="detail-section">
                        <h2 className="section-title">Postulante</h2>
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">Nombre</span>
                                <span className="info-value">
                                    {user.name || '-'} {user.lastname || ''}
                                </span>
                            </div>
                            <div className="info-item">
                                <span className="info-label">Email</span>
                                <span className="info-value">{user.email || '-'}</span>
                            </div>
                            {user.country && (
                                <div className="info-item">
                                    <span className="info-label">País</span>
                                    <span className="info-value">{user.country}</span>
                                </div>
                            )}
                            {user.city && (
                                <div className="info-item">
                                    <span className="info-label">Ciudad</span>
                                    <span className="info-value">{user.city}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Información de la Oportunidad */}
                {jobOrPractice && (
                    <div className="detail-section">
                        <h2 className="section-title">
                            {application.applicationType === 'job' ? 'Trabajo' : 'Práctica'}
                        </h2>
                        <div className="info-grid">
                            <div className="info-item">
                                <span className="info-label">Título</span>
                                <span className="info-value">{jobOrPractice.title || '-'}</span>
                            </div>
                            {jobOrPractice.company && (
                                <div className="info-item">
                                    <span className="info-label">Compañía</span>
                                    <span className="info-value">
                                        {typeof jobOrPractice.company === 'object' 
                                            ? jobOrPractice.company.name 
                                            : jobOrPractice.company}
                                    </span>
                                </div>
                            )}
                            {jobOrPractice.category && (
                                <div className="info-item">
                                    <span className="info-label">Categoría</span>
                                    <span className="info-value">{jobOrPractice.category}</span>
                                </div>
                            )}
                            {jobOrPractice.country && (
                                <div className="info-item">
                                    <span className="info-label">País</span>
                                    <span className="info-value">{jobOrPractice.country}</span>
                                </div>
                            )}
                            {jobOrPractice.city && (
                                <div className="info-item">
                                    <span className="info-label">Ciudad</span>
                                    <span className="info-value">{jobOrPractice.city}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {/* Información de la Postulación */}
                <div className="detail-section">
                    <h2 className="section-title">Información de la Postulación</h2>
                    <div className="info-grid">
                        <div className="info-item">
                            <span className="info-label">Tipo</span>
                            <span className="info-value">
                                {application.applicationType === 'job' ? 'Trabajo' : 'Práctica'}
                            </span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Etapa actual</span>
                            <span className="info-value">{translateStage(application.currentStage)}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Estado</span>
                            <span className="info-value">{translateStatus(application.status)}</span>
                        </div>
                        <div className="info-item">
                            <span className="info-label">Fecha de postulación</span>
                            <span className="info-value">{formatDate(application.appliedAt)}</span>
                        </div>
                        {application.updatedAt && (
                            <div className="info-item">
                                <span className="info-label">Última actualización</span>
                                <span className="info-value">{formatDate(application.updatedAt)}</span>
                            </div>
                        )}
                    </div>
                </div>

                {/* Notas */}
                {application.notes && (
                    <div className="detail-section">
                        <h2 className="section-title">Notas</h2>
                        <div className="notes-content">
                            {application.notes}
                        </div>
                    </div>
                )}

                {/* Historial de Etapas */}
                {application.stages && application.stages.length > 0 && (
                    <div className="detail-section">
                        <h2 className="section-title">Historial de Etapas</h2>
                        <div className="stages-timeline">
                            {application.stages.map((stage, index) => (
                                <div key={index} className="timeline-item">
                                    <div className="timeline-marker"></div>
                                    <div className="timeline-content">
                                        <div className="timeline-stage">{translateStage(stage.stage)}</div>
                                        <div className="timeline-date">{formatDate(stage.date)}</div>
                                        {stage.notes && (
                                            <div className="timeline-notes">{stage.notes}</div>
                                        )}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                )}
            </div>
        </ToolbarComponent>
    );
};

export default ApplicationDetailPage;









